const NEAR_BLACK = '#0e0e0f';
const NEAR_WHITE = '#ffffff';

function clamp255(x) {
  const n = Math.round(Number(x));
  if (Number.isNaN(n)) return 0;
  return Math.min(255, Math.max(0, n));
}

/**
 * @param {string} color
 * @returns {{ r: number; g: number; b: number } | null}
 */
export function parseCssColorToRgb(color) {
  if (!color || typeof color !== 'string') return null;
  const s = color.trim();
  const hex = s.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
  if (hex) {
    let h = hex[1];
    if (h.length === 3) {
      h = h.split('').map((c) => c + c).join('');
    }
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some((n) => Number.isNaN(n))) return null;
    return { r, g, b };
  }
  const rgb = s.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
  if (rgb) {
    return {
      r: clamp255(rgb[1]),
      g: clamp255(rgb[2]),
      b: clamp255(rgb[3]),
    };
  }
  return null;
}

function relativeLuminance(r, g, b) {
  const lin = (c) => {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  };
  const R = lin(r);
  const G = lin(g);
  const B = lin(b);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

/** WCAG 2 contrast ratio для двух относительных яркостей (0..1). */
function contrastRatio(L1, L2) {
  const lighter = Math.max(L1, L2);
  const darker = Math.min(L1, L2);
  return (lighter + 0.05) / (darker + 0.05);
}

/**
 * Цвет текста/иконок на сплошном фоне: почти чёрный или почти белый —
 * тот вариант, у которого выше контраст с фоном (WCAG 2).
 *
 * @param {string} backgroundColor — #hex или rgb()/rgba(); иначе тёмный текст
 * @returns {typeof NEAR_BLACK | typeof NEAR_WHITE}
 */
export function contrastTextOnBackground(backgroundColor) {
  const rgb = parseCssColorToRgb(backgroundColor);
  if (!rgb) return NEAR_BLACK;
  const Lbg = relativeLuminance(rgb.r, rgb.g, rgb.b);
  const Lblack = relativeLuminance(14, 14, 15);
  const Lwhite = relativeLuminance(255, 255, 255);
  const withBlack = contrastRatio(Lblack, Lbg);
  const withWhite = contrastRatio(Lwhite, Lbg);
  return withBlack >= withWhite ? NEAR_BLACK : NEAR_WHITE;
}
